import { useMemo } from "react";
import type { HMSConfig } from "@100mslive/react-sdk";
import { selectSettings, useLiveStore } from "../../store";
import type { ParticipantMetadata } from "../types";
import { useRoom } from "../useRoom";

export const useHMSConfig = (
  participant: ParticipantMetadata | null,
  authToken = "",
) => {
  const settings = useLiveStore(selectSettings);
  const circleRoom = useRoom();
  const shouldMuteOnJoin =
    !!circleRoom?.mute_on_join && !circleRoom?.can_manage;

  const config: HMSConfig = useMemo(
    () => ({
      userName: participant?.name ?? "",
      authToken: authToken,
      metaData: JSON.stringify(participant || {}),
      rememberDeviceSelection: false,
      captureNetworkQualityInPreview: true,
      settings: {
        isAudioMuted: shouldMuteOnJoin || !settings.microphoneEnabled,
        isVideoMuted: !settings.cameraEnabled,
        audioInputDeviceId: settings.audioInputId,
        audioOutputDeviceId: settings.audioOutputId ?? undefined,
        videoDeviceId: settings.videoInputId,
        speakerAutoSelectionBlacklist: "all",
      },
    }),
    [participant, authToken, shouldMuteOnJoin, settings],
  );

  return config;
};
